import { ReactComponent as IconDownload } from "@/assets/svgs/download-white.svg";
import { ReactComponent as IconCheck } from "@/assets/svgs/check.svg";
import { ReactComponent as IconChevronRight } from "@/assets/svgs/chevron-right-black.svg";
import { ReactComponent as IconDocumentLine } from "@/assets/svgs/icon-document-line.svg";
import { ReactComponent as IconPhoto } from "@/assets/svgs/icon-photo.svg";
import classname from "classnames";
import { uniqueId } from "lodash";
import { useRef, useState } from "react";
import FileSaver from "file-saver";
import JSZip from "jszip";
import PropTypes from "prop-types";

const AttachmentUtility = ({ text = "Preview", attachments, setAttachmentIndex, attachmentIndex }) => {
	const zip = new JSZip();
	const [scrollPos, setScrollPos] = useState(0);
	const contentRef = useRef(null);
	const holderRef = useRef(null);
	const handleRightClick = () => {
		if (contentRef.current) {
			const containerWidth = contentRef.current?.scrollWidth - contentRef.current?.offsetWidth;
			const newScrollPos = scrollPos - 100;
			setScrollPos(Math.abs(newScrollPos) > containerWidth ? -containerWidth : newScrollPos);
		}
	};

	const handleLeftClick = () => {
		const newScrollPos = scrollPos + 100;
		setScrollPos(newScrollPos > 0 ? 0 : newScrollPos);
	};
	const handleDownloadAllAttachments = () => {
		attachments.forEach((attachment)=>{
			if (attachment?.downloadHref && attachment?.filename && attachment?.hasBase64) {
				let idx = attachment.downloadHref.indexOf("base64,") + "base64,".length;
				let content = attachment.downloadHref.substring(idx);
				zip.file(attachment.filename, content, {base64: true});
			}
		})
		zip.generateAsync({type:"blob"}).then(function (cont) {
			FileSaver.saveAs(cont, "attachments.zip");
	   });
	}

	const file_name_button__wrapper = classname({
		"file_name_button__wrapper": true,
		"file_name_button__wrapper-right_border": scrollPos - holderRef.current?.offsetWidth + contentRef.current?.scrollWidth > 0,
		"file_name_button__wrapper-left_border": scrollPos !== 0,
	})

	return (
		<div className="success__page__attachments" data-testid="success__page__attachments">
			<div className="attachments_container">
				<div className="preview_container">
					<span className="preview_title__color__grey">
						{text}:
					</span>
					<div className="file_container">
						<div className="file_name_button__controller file_name_button__controller--left-button" data-testid="file_name_button__controller--left-button">
							<IconChevronRight
								onClick={handleLeftClick}
							/>
						</div>
						<div className={file_name_button__wrapper} ref={holderRef}>
							<div className="file_name_button_container" data-testid="file_name_button_container" style={{ transform: `translateX(${scrollPos}px)` }} ref={contentRef}>
								{attachments.map((attachment, index) => {
									const fileExtension = attachment?.filename?.split(".").pop();

									const id = uniqueId();

									const currentSelected = attachmentIndex === index;

									const fileNameButtonClass = classname({
										"file_name_button": true,
										"selected_file_name_button": currentSelected
									})

									return (
										<span className={fileNameButtonClass}
											data-testid={"attachment-button"}
											onClick={() => {
												setAttachmentIndex(index);
											}}
											key={id}
											data-tooltip-id="tooltip"
											data-tooltip-content={attachment.filename}
										>
											<span className="icon__span">
												{currentSelected && <IconCheck />}
												{!currentSelected && (fileExtension === "jpg" || fileExtension === "png") && <IconPhoto />}
												{!currentSelected && !(fileExtension === "jpg" || fileExtension === "png") && <IconDocumentLine />}
											</span>
											<div className="file_name_button__text">
												{attachment.filename}
											</div>
										</span>
									);
								})}
							</div>
						</div>
						<div className="file_name_button__controller file_name_button__controller--right-button" data-testid="file_name_button__controller--right-button">
							<IconChevronRight
								onClick={handleRightClick}
							/>
						</div>
					</div>
					<div className="preview_download__btn">
						<a
							href='#'
							role="button"
							onClick={handleDownloadAllAttachments}
							data-testid={'download_attachments'}
							data-tooltip-id="tooltip"
							data-tooltip-content="Download all attachments"
						>
							<IconDownload />
						</a>
					</div>
				</div>
			</div>
		</div>
	)
}

AttachmentUtility.propTypes = {
	text: PropTypes.string,
	attachments: PropTypes.array,
	setAttachmentIndex: PropTypes.func,
	attachmentIndex: PropTypes.number
}

export default AttachmentUtility
